<div class="custom-dropdown">
  <div [ngClass]=" addUser? 'users-dropdown-label' : 'dropdown-label' " (click)="toggleDropdown()">
    <div class="dropdownText">{{ selectedOption }}</div>
    <img src="../../../assets/Images/user-management/dropdown__arrow.svg" alt="arrow">
  </div>
  @if (isDropdownOpen) {
    <div class="dropdown-menu" [class.show]="isDropdownOpen">
      @for (option of options; track option) {
        <div class="dropdown-option">
          <input type="checkbox" [id]="'checkbox-' + option.value" [checked]="selectedOptions.includes(option)"
            (change)="toggleOption($event, option)" />
            <label>{{ option.name }}</label>
          </div>
        }
      </div>
    }
  </div>
